import React from 'react';
import { useState, useEffect } from 'react';
import makePageSections from '../../../../templates/page-builder-helpers';

import { RelatedArticlesPropTypes } from './Types/RelatedArticlesTypes';

const RelatedArticles = ({ contentfulData, subCategory, page }: RelatedArticlesPropTypes) => {
  const [articlelist, setArticleList] = useState<string[]>();

  const filterRelatedVhubArticles = () => {
    const switchArticle = page === "search" ?
      contentfulData.mappingSubcategory.searchMapping
      : contentfulData.mappingSubcategory.assessmentMapping;

    const filterVhubTag = switchArticle.filter((element: any) => {
      const filterArticle = element.split(':');
      if (filterArticle[0].toLowerCase() === subCategory.toLowerCase()) {
        return element;
      };
    });

    const getVhubTag = filterVhubTag.length > 1 ? filterVhubTag[0].toString().split(':')[1] :
      filterVhubTag.toString().split(':')[1];

    const relatedArticlesList = contentfulData?.relatedArticlesList ? contentfulData?.relatedArticlesList?.content[0] : null;

    if (contentfulData.relatedArticlesList && contentfulData.relatedArticlesList.content.length > 0 && relatedArticlesList.content.length > 0) {
      const articleIndex = relatedArticlesList.content.filter((obj: any) => {
        return obj.__typename === "ContentfulSectionElementArticleIndex";
      });

      const totalArticles = articleIndex[0].defaultArticlesList ? articleIndex[0].defaultArticlesList : articleIndex[0].articles;
      
      const filterArticles = totalArticles.filter((e: any) => {
        const filterTopicTag = e.topicTags.filter((x: any) => {
          return x.name === `${getVhubTag}`;
        });
        if (filterTopicTag.length > 0) {
          return e;
        };
      });

      if (filterArticles.length > 0) {
        const sections = contentfulData.relatedArticlesList;
        const updateSections = sections.content[0].content.find((obj: any) =>
          obj.__typename === "ContentfulSectionElementArticleIndex"
        );
        Object.assign(updateSections, { articles: filterArticles });
        setArticleList(makePageSections([sections], "", "", "", ""));
      } else {
        setArticleList(makePageSections([contentfulData.defaultArticlesList], "", "", "", ""));
      };
    };
  };

  useEffect(() => {
    subCategory && filterRelatedVhubArticles();
  }, [subCategory]);

  return (
    <div>
      {articlelist}
    </div>
  );
};
export default RelatedArticles;
